import React from "react";
import downIcon from "../../../../assets/images/classes/downIcon.svg";

const DropDownLessonChapter = ({
                                   chapters,
                                   selectedChapter,
                                   setSelectedChapter,
                                   openDropdown,
                                   setOpenDropdown,
                                    setLessonInfoId
                               }) => {
    const isOpen = openDropdown === "chapter"; // ✅ 현재 열린 드롭다운이 "chapter"인지 확인

    return (
        <div className="relative">
            <button
                onClick={() => setOpenDropdown(isOpen ? null : "chapter")} // ✅ 클릭 시 다른 드롭다운 닫기
                className="inline-flex w-[229px] h-[44px] justify-center items-center gap-x-1.5 rounded-[10px] bg-white px-3 py-2 font-[500] text-[18px] text-[#000] shadow-custom ring-1 ring-inset ring-gray-300 hover:bg-gray-50 z-20 relative"
            >
                <div className="relative left-0 right-0 text-left w-full pr-2">
                    {selectedChapter ? selectedChapter.chapterName : "단원 선택"}
                </div>
                <img src={downIcon} alt="downIcon" className="ml-auto mr-[0px] w-4" />
            </button>

            {isOpen && (
                <div className="absolute w-full z-10 origin-top rounded-b-[10px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden scrollbar-hide max-h-[300px] opacity-100">
                    <div className="max-h-[300px] overflow-y-auto bg-[#F1F1F1] pt-2">
                        {chapters.map((chapter) => (
                            <div
                                key={chapter.chapterId}
                                className="cursor-pointer hover:bg-blue-50 p-2 truncate text-left ml-[10px]"
                                onClick={() => {
                                    setSelectedChapter(chapter);
                                    setLessonInfoId(null);
                                    setOpenDropdown(null); // ✅ 선택 후 드롭다운 닫기
                                }}
                            >
                                {chapter.chapterName}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownLessonChapter;
